(function () {
  "use strict";

  var motionProfiles = [
    { start: 54, rotate: -132, scale: 0.045, phase: 0.55 },
    { start: 128, rotate: 64, scale: 0.022, phase: 0.85 },
    { start: -76, rotate: -96, scale: 0.032, phase: 1.2 },
    { start: 202, rotate: 148, scale: 0.018, phase: 1.55 },
    { start: 34, rotate: -74, scale: 0.048, phase: 0.25 },
    { start: -116, rotate: 124, scale: 0.024, phase: 0.7 },
    { start: 86, rotate: -88, scale: 0.036, phase: 1 },
    { start: 166, rotate: 104, scale: 0.026, phase: 1.35 },
    { start: -42, rotate: -146, scale: 0.046, phase: 1.7 },
    { start: 238, rotate: 72, scale: 0.02, phase: 0.42 },
    { start: -154, rotate: -118, scale: 0.038, phase: 1.48 },
    { start: 72, rotate: 96, scale: 0.026, phase: 0.32 },
    { start: -208, rotate: -84, scale: 0.02, phase: 1.12 },
    { start: 286, rotate: 126, scale: 0.036, phase: 0.92 }
  ];

  function toArray(items) {
    return Array.prototype.slice.call(items || []);
  }

  function closestByClass(element, className) {
    var current = element;

    while (current && current !== document) {
      if (current.classList && current.classList.contains(className)) {
        return current;
      }
      current = current.parentNode;
    }

    return null;
  }

  function initMenu(root) {
    var scope = root || document;
    var headers = toArray(scope.querySelectorAll("[data-site-header]"));

    headers.forEach(function (header) {
      if (header.getAttribute("data-menu-ready") === "true") return;

      var toggle = header.querySelector("[data-menu-toggle]");
      var nav = header.querySelector("[data-mobile-nav]");
      var label = header.querySelector("[data-menu-label]");

      if (!toggle || !nav || !label) return;

      function closeMenu() {
        toggle.setAttribute("aria-expanded", "false");
        nav.classList.remove("is-open");
        nav.setAttribute("aria-hidden", "true");
        label.textContent = "Menu";
        document.documentElement.classList.remove("menu-is-open");
      }

      toggle.addEventListener("click", function () {
        var isOpen = toggle.getAttribute("aria-expanded") !== "true";

        toggle.setAttribute("aria-expanded", String(isOpen));
        nav.setAttribute("aria-hidden", String(!isOpen));
        label.textContent = isOpen ? "Close" : "Menu";

        if (isOpen) {
          nav.classList.add("is-open");
          document.documentElement.classList.add("menu-is-open");
        } else {
          nav.classList.remove("is-open");
          document.documentElement.classList.remove("menu-is-open");
        }
      });

      toArray(nav.querySelectorAll("a")).forEach(function (link) {
        link.addEventListener("click", closeMenu);
      });

      window.addEventListener("keydown", function (event) {
        if (event.key === "Escape" || event.keyCode === 27) closeMenu();
      });

      window.addEventListener("resize", function () {
        if (window.innerWidth > 980) closeMenu();
      });

      nav.setAttribute("aria-hidden", "true");
      header.setAttribute("data-menu-ready", "true");
    });
  }

  function initCarousels(root) {
    var scope = root || document;
    var carousels = toArray(scope.querySelectorAll("[data-carousel]"));

    carousels.forEach(function (carousel) {
      if (carousel.getAttribute("data-carousel-ready") === "true") return;

      var viewport = carousel.querySelector("[data-carousel-viewport]");
      var track = carousel.querySelector("[data-carousel-track]");
      var slides = toArray(carousel.querySelectorAll("[data-carousel-slide]"));
      var dots = toArray(carousel.querySelectorAll("[data-carousel-dot]"));
      var previous = carousel.querySelector("[data-carousel-previous]");
      var next = carousel.querySelector("[data-carousel-next]");
      var active = 0;
      var dragStart = null;

      if (!viewport || !track || slides.length === 0) return;

      function goTo(index) {
        var slideIndex;
        var controlIndex;
        var controls;
        var selected;
        var dotIndex;

        active = (index + slides.length) % slides.length;
        track.style.transform = "translate3d(-" + (active * 100) + "%, 0, 0)";

        for (slideIndex = 0; slideIndex < slides.length; slideIndex += 1) {
          selected = slideIndex === active;
          slides[slideIndex].setAttribute("aria-hidden", String(!selected));
          controls = slides[slideIndex].querySelectorAll("a, button, input, select, textarea");

          for (controlIndex = 0; controlIndex < controls.length; controlIndex += 1) {
            controls[controlIndex].tabIndex = selected ? 0 : -1;
          }
        }

        for (dotIndex = 0; dotIndex < dots.length; dotIndex += 1) {
          selected = dotIndex === active;

          if (selected) {
            dots[dotIndex].classList.add("is-active");
            dots[dotIndex].setAttribute("aria-current", "true");
          } else {
            dots[dotIndex].classList.remove("is-active");
            dots[dotIndex].removeAttribute("aria-current");
          }
        }
      }

      function finishDrag(clientX) {
        var distance;

        if (dragStart === null) return;

        distance = clientX - dragStart;
        if (Math.abs(distance) > 48) {
          goTo(active + (distance < 0 ? 1 : -1));
        }
        dragStart = null;
      }

      if (previous) {
        previous.addEventListener("click", function () {
          goTo(active - 1);
        });
      }

      if (next) {
        next.addEventListener("click", function () {
          goTo(active + 1);
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener("click", function () {
          goTo(Number(dot.getAttribute("data-carousel-dot")) || 0);
        });
      });

      viewport.addEventListener("keydown", function (event) {
        if (event.key === "ArrowLeft" || event.keyCode === 37) goTo(active - 1);
        if (event.key === "ArrowRight" || event.keyCode === 39) goTo(active + 1);
      });

      if (window.PointerEvent) {
        viewport.addEventListener("pointerdown", function (event) {
          dragStart = event.clientX;

          if (typeof viewport.setPointerCapture === "function") {
            try {
              viewport.setPointerCapture(event.pointerId);
            } catch (error) {
              /* Pointer capture is optional. */
            }
          }
        });

        viewport.addEventListener("pointerup", function (event) {
          finishDrag(event.clientX);
        });

        viewport.addEventListener("pointercancel", function () {
          dragStart = null;
        });
      } else {
        viewport.addEventListener("touchstart", function (event) {
          if (event.touches && event.touches.length === 1) {
            dragStart = event.touches[0].clientX;
          }
        }, false);

        viewport.addEventListener("touchend", function (event) {
          if (event.changedTouches && event.changedTouches.length) {
            finishDrag(event.changedTouches[0].clientX);
          }
        }, false);

        viewport.addEventListener("touchcancel", function () {
          dragStart = null;
        }, false);
      }

      goTo(0);
      carousel.setAttribute("data-carousel-ready", "true");
    });
  }

  function initLemonField() {
    var field = document.querySelector("[data-lemon-field]");
    var page = field ? closestByClass(field, "page-shell") : null;
    var fruit;
    var reducedMotion;
    var motionFactor;
    var frame = 0;

    if (!field || !page || field.getAttribute("data-motion-ready") === "true") return;

    fruit = toArray(field.querySelectorAll(".page-lemon"));
    motionFactor = parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue("--lemon-motion")) || 1;
    reducedMotion = window.matchMedia
      ? window.matchMedia("(prefers-reduced-motion: reduce)")
      : { matches: false };

    function update() {
      var travel = Math.max(1, page.scrollHeight - window.innerHeight);
      var progress = Math.max(0, Math.min(1, window.pageYOffset / travel));
      var index;
      var profile;
      var turn;
      var pulse;

      frame = 0;

      for (index = 0; index < fruit.length; index += 1) {
        profile = motionProfiles[index];
        if (!profile) continue;

        turn = profile.start + progress * profile.rotate * motionFactor;
        pulse = 1 + Math.sin((progress + profile.phase) * Math.PI * 2) * profile.scale * motionFactor;
        fruit[index].style.transform = "rotateZ(" + turn.toFixed(2) + "deg) scale(" + pulse.toFixed(4) + ")";
      }
    }

    function requestUpdate() {
      if (!frame) frame = window.requestAnimationFrame(update);
    }

    fruit.forEach(function (piece, index) {
      if (motionProfiles[index]) {
        piece.style.transform = "rotateZ(" + motionProfiles[index].start + "deg)";
      }
    });

    if (!reducedMotion.matches) {
      update();
      window.addEventListener("scroll", requestUpdate, false);
      window.addEventListener("resize", requestUpdate, false);
    }

    field.setAttribute("data-motion-ready", "true");
  }

  function formatPrice(cents) {
    var currency = "NZD";

    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      currency = window.Shopify.currency.active;
    }

    if (window.Intl && window.Intl.NumberFormat) {
      try {
        return new window.Intl.NumberFormat(undefined, {
          style: "currency",
          currency: currency
        }).format(cents / 100);
      } catch (error) {
        /* Continue to the basic fallback below. */
      }
    }

    return "$" + (cents / 100).toFixed(2);
  }

  function updateVariantUrl(variantId) {
    var search;
    var nextUrl;

    if (!window.history || !window.history.replaceState) return;

    search = window.location.search || "";

    if (/([?&])variant=[^&]*/.test(search)) {
      search = search.replace(/([?&])variant=[^&]*/, "$1variant=" + variantId);
    } else {
      search += (search ? "&" : "?") + "variant=" + variantId;
    }

    nextUrl = window.location.pathname + search + window.location.hash;
    window.history.replaceState({}, "", nextUrl);
  }

  function initProductForms(root) {
    var scope = root || document;
    var productMains = toArray(scope.querySelectorAll(".product-main"));

    productMains.forEach(function (productMain) {
      var select;
      var parent;
      var json;
      var price;
      var addButton;
      var addButtonLabel;
      var variants;

      if (productMain.getAttribute("data-product-ready") === "true") return;

      select = productMain.querySelector("[data-variant-select]");
      parent = productMain.parentElement;
      json = parent ? parent.querySelector("[data-product-json]") : null;
      price = productMain.querySelector("[data-product-price]");
      addButton = productMain.querySelector('button[name="add"]');
      addButtonLabel = addButton ? addButton.querySelector("span:first-child") : null;

      if (!select || !json || !price) {
        productMain.setAttribute("data-product-ready", "true");
        return;
      }

      try {
        variants = JSON.parse(json.textContent || "[]");
      } catch (error) {
        return;
      }

      select.addEventListener("change", function () {
        var selectedVariant = null;
        var index;

        for (index = 0; index < variants.length; index += 1) {
          if (String(variants[index].id) === select.value) {
            selectedVariant = variants[index];
            break;
          }
        }

        if (!selectedVariant) return;

        price.textContent = formatPrice(selectedVariant.price);
        if (addButton) {
          addButton.disabled = !selectedVariant.available;
          addButton.setAttribute("aria-disabled", String(!selectedVariant.available));
        }
        if (addButtonLabel) {
          addButtonLabel.textContent = selectedVariant.available ? "Add to cart" : "Sold out";
        }
        updateVariantUrl(selectedVariant.id);
      });

      productMain.setAttribute("data-product-ready", "true");
    });
  }

  function init(root) {
    initMenu(root);
    initCarousels(root);
    initProductForms(root);
    initLemonField();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
}());
